import { useCallback, useState } from 'react'
import Project from 'common/project'
import { articleType } from 'pages/articles/components/article'

export default function useBlog({ slug }: { slug: string }) {
  const [blog, setBlog] = useState<articleType>()
  const [recommendedBlogs, setRecommendedBlogs] = useState<articleType[]>([])
  const [blogLoading, setBlogLoading] = useState(true)
  const [recommendedBlogsLoading, setRecommendedBlogsLoading] = useState(true)

  const getBlog = useCallback(() => {
    fetch(`${Project.liveApi}website/who-we-are/blogs/${slug}`)
      .then((response) => response.json())
      .then(setBlog)
      .then(() => setBlogLoading(false))
  }, [slug])

  const getRecommendedBlogs = useCallback(() => {
    fetch(`${Project.liveApi}website/who-we-are/blogs`)
      .then((response) => response.json())
      .then((data) => {
        const filteredResults = data.results.filter(
          (blog: { slug: string }) => blog.slug !== slug,
        )
        setRecommendedBlogs(filteredResults)
      })
      .finally(() => setRecommendedBlogsLoading(false))
  }, [])

  return {
    blog,
    getBlog,
    getRecommendedBlogs,
    blogLoading,
    recommendedBlogsLoading,
    recommendedBlogs,
  }
}
